import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import qs from "qs";

import Icon from "../Icon";
import copy from "utils/clipboard";
import styles from "./SocialIcons.css";

export default class SocialIcons extends React.Component {

  constructor(props) {
    super(props);
    this.state = { clipboardConfirmOpen: false };
    this.copyPermalink = this._copyPermalink.bind(this);
    this.openInNewWindow = this._openInNewWindow.bind(this);
  }

  _openInNewWindow(url) {
    const strParam = "width=500,height=400,resizable=yes";
    window.open(url, "Share story", strParam).focus();
  }

  _copyPermalink(e) {
    e.preventDefault();

    copy(this.props.permalink);
    this.setState({ clipboardConfirmOpen: true });
    setTimeout(() => { this.setState({ clipboardConfirmOpen: false }) }, 1000);
  }

  render() {
    const endpoints = [
      {
        url: "https://www.facebook.com/sharer/sharer.php?u=",
        name: "facebook",
        params: { utm_source: "linkedin", utm_medium: "lisocialshare", utm_campaign: "organic" },
      },
      {
        url: "https://twitter.com/intent/tweet?url=",
        name: "twitter",
        params: { utm_source: "twitter", utm_medium: "twsocialshare", utm_campaign: "organic" },
        extraParams: { text: this.props.headline },
      },
      {
        url: "https://www.linkedin.com/sharing/share-offsite?url=",
        name: "linkedin",
        params: { utm_source: "linkedin", utm_medium: "lisocialshare", utm_campaign: "organic" },
        extraParams: { mini: false },
      },
    ];

    const shareLocations = endpoints.map((share) => {
      let url, rest, hash;
      let params = {};

      [url, rest] = this.props.permalink.split("?");
      if (rest) { [params, hash] = rest.split("#") }

      const newParams = { ...qs.parse(params), ...share.params };
      const sharedUrl = encodeURIComponent(`${url}?${qs.stringify(newParams)}${ hash ? `#${hash}` : "" }`);

      return {
        url: `${share.url}${sharedUrl}${ share.extraParams ? `&${qs.stringify(share.extraParams)}` : "" }`,
        name: share.name,
      };
    });

    return (
      <div className={classNames(styles.root, this.props.className)}>
        {Object.values(shareLocations).map((share) => {
          return (
            <a key={share.name} target="_new" onClick={(e) => { e.preventDefault(); this.openInNewWindow(share.url) }} aria-label={share.name} className={classNames(styles.button, `gtm-${share.name}`)}>
              <div className={classNames(styles.container, this.props.inverse ? styles.circle : {})}>
                <Icon name={`${share.name}${this.props.inverse ? "-inverse" : ""}`} path="img" description={share.name} className={styles.icon}/>
              </div>
            </a>
          );
        })}
        <div className={classNames(styles.clipboardWrapper, "gtm-copy-link")}>
          { this.state.clipboardConfirmOpen ? (
            <div className={styles.clipboardConfirm}>
              <Icon name="clipboard" path="icons" description="copy" className={styles.icon} />
              <span>Link copied to clipboard</span>
            </div>
          ) : null }
          <a onClick={this.copyPermalink} aria-label={"Copy url"} className={styles.button}>
            <div className={classNames(styles.container, this.props.inverse ? styles.circle : {})}>
              <Icon name={`link${this.props.inverse ? "-inverse" : ""}`} path="img" description={"copy"} className={styles.icon}/>
            </div>
          </a>
        </div>
      </div>
    );
  }
}

SocialIcons.propTypes = {
  permalink:  PropTypes.string.isRequired,
  headline: PropTypes.string.isRequired,
  className: PropTypes.string,
  inverse: PropTypes.bool,
};

SocialIcons.defaultProps = {
  inverse: false,
};
